import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



interface Props {
	text?: string;
}
interface Emits {
	(e: "click"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BlueBtn',
  props: {
    text: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const handleClick = () => {
	emit("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _withModifiers(handleClick, ["stop"]),
    class: "link-large-underline link-default py-2 px-3 cursor-pointer"
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(props.text), 1)
    ])
  ]))
}
}

})